// src/pages/Users/Galleries/components/AlbumPhotoGrid.jsx

import React, { useRef, useState } from "react";

import AlbumPhotoCard from "./AlbumPhotoCard";

export default function AlbumPhotoGrid({
  photos = [],
  fullPhotos = [],
  isManager,
  moving,
  onOpen,
  onToggleCover,
  onMovePhoto,
}) {
  const [draggingIndex, setDraggingIndex] = useState(null);
  const [overIndex, setOverIndex] = useState(null);

  const dragRef = useRef({
    from: null,
  });

  const handleDragStart = (event, index) => {
    if (!isManager) return;

    dragRef.current.from = index;
    setDraggingIndex(index);

    event.dataTransfer.effectAllowed = "move";

    try {
      event.dataTransfer.setData("text/plain", String(index));
    } catch {
      // Non bloquant.
    }
  };

  const handleDragOver = (event, index) => {
    if (!isManager) return;

    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    setOverIndex(index);
  };

  const handleDrop = (event, toIndex) => {
    if (!isManager) return;

    event.preventDefault();

    let fromIndex = dragRef.current.from;

    try {
      const data = event.dataTransfer.getData("text/plain");
      if (data !== "") {
        fromIndex = Number(data);
      }
    } catch {
      // Non bloquant.
    }

    setDraggingIndex(null);
    setOverIndex(null);
    dragRef.current.from = null;

    if (!Number.isFinite(fromIndex)) return;
    if (fromIndex === toIndex) return;

    onMovePhoto?.(fromIndex, toIndex);
  };

  const handleDragEnd = () => {
    setDraggingIndex(null);
    setOverIndex(null);
    dragRef.current.from = null;
  };

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
      {photos.map((photo, index) => (
        <AlbumPhotoCard
          key={photo.id || index}
          photo={photo}
          index={index}
          total={fullPhotos.length}
          isManager={isManager}
          moving={moving}
          isDragging={draggingIndex === index}
          isOver={overIndex === index}
          onOpen={() => onOpen(index)}
          onToggleCover={() => onToggleCover(photo)}
          onMoveUp={() => onMovePhoto(index, index - 1)}
          onMoveDown={() => onMovePhoto(index, index + 1)}
          onDragStart={(event) => handleDragStart(event, index)}
          onDragOver={(event) => handleDragOver(event, index)}
          onDrop={(event) => handleDrop(event, index)}
          onDragEnd={handleDragEnd}
        />
      ))}
    </div>
  );
}